import React from 'react';
import {
  WalletOutlined,
  CreditCardOutlined,
  MobileOutlined,
  BankOutlined,
} from '@ant-design/icons';
import { PaymentMode } from '../constants';

interface PaymentModeIconProps {
  mode: PaymentMode;
}

export const PaymentModeIcon: React.FC<PaymentModeIconProps> = ({ mode }) => {
  switch (mode) {
    case 'CASH':
      return <WalletOutlined />;
    case 'GPAY':
      return <MobileOutlined />;
    default:
      return null;
  }
};
